export default __webpack_public_path__ + "static/ml-1-95aa900b2fd16fa6f28b8c5318ebcfae.png";